import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import cdic from "../img/cdic.svg";
import socialData from "../data/socialData";
import footerNotes from "../data/footerNotes";

export const FooterNotes = () => {
  const social = socialData();
  const notes = footerNotes();

  return (
    <Wrapper>
      <div className="important">
        <p>
          * Interest is calculated daily on the total closing balance and paid
          monthly. Rates are per annum and subject to change without notice.
          Return to footnote*referrerFootnote ◊ Based on research conducted by
          Equitable Bank comparing HISA interest rates of Canada’s ‘Big 5’ banks
          over a 12-month span on an investment of $100. Assumes no additional
          deposits or withdrawals made. Research considered comparable
          high-interest savings account interest rates based on data taken from
          public websites as at June 19, 2020. Promotions and Rate Premiums are
          excluded.
        </p>

        <div>
          <img src={cdic} alt="cdic badge" />
          <p> CDIC Deposit Insurance Information</p>
        </div>
      </div>

      <div className="service-links">
        <h3>Follow Us</h3>

        <div className="social">
          {social.map((e) => {
            return (
              <div key={e.index}>
                <img src={e.img} alt={e.title} />
              </div>
            );
          })}
        </div>

        <div className="notes">
          {notes.map((e) => {
            return <p key={e.index}> {e.title} </p>;
          })}
        </div>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled(motion.div)`
  min-height: 50vh;
  padding: 2rem 3rem;
  margin: auto;

  display: flex;

  h2,
  h3,
  h4,
  h5,
  p,
  a {
    white-space: normal;
    font-family: "Roboto", sans-serif;
  }

  @media (min-width: 1600px) {
    width: 100rem;
    min-height: 25rem;
  }

  @media (max-width: 900px) {
    flex-wrap: wrap;
  }

  @media (max-width: 500px) {
    padding: 1rem 1rem;
  }

  .important {
    margin: 2rem 0rem;
    width: 100%;

    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
    align-items: flex-start;

    flex-direction: column;

    @media (max-width: 500px) {
      text-align: center;
      padding: 0rem 1rem;
      align-items: center;
    }

    p {
      font-size: 0.8rem;
      line-height: 1.2rem;
      padding-bottom: 1rem;
    }

    div {
      display: flex;
      align-items: center;

      img {
        width: 9rem;
        @media (max-width: 500px) {
          padding: 0.5rem;
        }
      }

      p {
        padding-left: 1rem;
        text-decoration: underline;
        font-size: 0.9rem;

        @media (max-width: 500px) {
          padding: 0.5rem;
        }
      }
    }

    flex: 1 1 40rem;
  }

  .service-links {
    margin: 2rem 2rem;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
    width: 100%;

    flex: 1 1 40rem;

    @media (max-width: 900px) {
      align-items: center;
      margin: 2rem 0rem;
    }

    @media (max-width: 500px) {
      margin: 2rem 0rem;
      margin-bottom: 0rem;
    }

    h3 {
      @media (max-width: 900px) {
        align-items: left;
        padding: 2rem 0rem;
      }
    }

    .social {
      width: 100%;

      display: flex;
      align-items: center;
      text-align: right;
      justify-content: flex-end;
      @media (max-width: 900px) {
        padding: 1rem 5rem;

        justify-content: space-between;
      }

      @media (max-width: 500px) {
        padding: 1rem 2rem;
      }

      div {
        padding-left: 4rem;
        cursor: pointer;

        @media (max-width: 1200px) {
          padding-left: 2rem;
        }
        @media (max-width: 900px) {
          padding: 0.5rem;
        }
      }
    }
    .notes {
      display: flex;
      align-items: center;
      text-align: right;
      justify-content: flex-end;
      width: 100%;

      @media (max-width: 900px) {
        padding: 1rem 2rem;

        justify-content: space-between;
      }

      @media (max-width: 550px) {
        flex-wrap: wrap;
        flex-direction: column;
        text-align: center;
      }

      p {
        padding-left: 3rem;
        font-weight: bold;

        &:hover {
          cursor: pointer;
          color: #11698e;
        }

        @media (max-width: 1200px) {
          padding-left: 2rem;
        }

        @media (max-width: 900px) {
          padding: 0rem;
        }

        @media (max-width: 550px) {
          padding: 1rem;
          text-align: center;
        }
      }
    }
  }
`;
